module.exports = __webpack_public_path__ + "img/9.fd5a6dab.jpg";